import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, FileCheck, Zap, HeadphonesIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-[#0B0E13] text-[#F5F0E8] relative overflow-hidden" data-id="element-94">
      {/* Background accent */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4A843]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-95" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-97">
          <div className="inline-flex items-center justify-center p-4 bg-[#1A1F2E] rounded-full mb-6 border border-[#D4A843]/30 shadow-[0_0_30px_rgba(212,168,67,0.15)]" data-id="element-98">
            <ShieldCheck className="w-10 h-10 text-[#D4A843]" data-id="element-99" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-100">
            Garantía de Calidad: <br className="md:hidden" data-id="element-101" />
            <span className="text-[#D4A843]" data-id="element-102">Tu Compra Está Protegida</span>
          </h2>
          <p className="text-[#8B8578] max-w-2xl mx-auto text-lg" data-id="element-103">
            Si no puedes acceder al material, te ayudamos hasta que funcione.
            Punto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-104">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#1A1F2E] p-8 rounded-2xl border border-[#D4A843]/10 text-center hover:border-[#D4A843]/30 transition-colors" data-id="element-105">
            <div className="w-12 h-12 bg-[#0B0E13] rounded-full flex items-center justify-center mx-auto mb-6 border border-[#D4A843]/20" data-id="element-106">
              <FileCheck className="w-6 h-6 text-[#4A8B6E]" data-id="element-107" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-[#F5F0E8]" data-id="element-108">
              Contenido Verificable
            </h3>
            <p className="text-[#8B8578] text-sm leading-relaxed" data-id="element-109">
              Cada script, checklist y punto de riesgo está basado en
              situaciones reales del proceso de compra en USA.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#1A1F2E] p-8 rounded-2xl border border-[#D4A843]/10 text-center hover:border-[#D4A843]/30 transition-colors" data-id="element-110">
            <div className="w-12 h-12 bg-[#0B0E13] rounded-full flex items-center justify-center mx-auto mb-6 border border-[#D4A843]/20" data-id="element-111">
              <Zap className="w-6 h-6 text-[#D4A843]" data-id="element-112" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-[#F5F0E8]" data-id="element-113">
              Descarga Inmediata
            </h3>
            <p className="text-[#8B8578] text-sm leading-relaxed" data-id="element-114">
              Acceso instantáneo después del pago. Sin esperas, sin
              complicaciones. Lo tienes en tu teléfono en segundos.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-[#1A1F2E] p-8 rounded-2xl border border-[#D4A843]/10 text-center hover:border-[#D4A843]/30 transition-colors" data-id="element-115">
            <div className="w-12 h-12 bg-[#0B0E13] rounded-full flex items-center justify-center mx-auto mb-6 border border-[#D4A843]/20" data-id="element-116">
              <HeadphonesIcon className="w-6 h-6 text-[#C75B3A]" data-id="element-117" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-[#F5F0E8]" data-id="element-118">
              Soporte Real
            </h3>
            <p className="text-[#8B8578] text-sm leading-relaxed" data-id="element-119">
              ¿Problema con la descarga? Te ayudamos. Escríbenos y lo
              resolvemos. No te dejamos sola con un PDF roto.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}